import { useState } from "react";
import HasPermission from "../../claims/SessionClaims";
import { teacher_permission } from "../../config";
import { addSignVocab } from "../../services/api";
import SignVocab from "../../models/SignVocab";
import Vocab from "../../models/Vocab";

interface SignVocabAddFormProp {
    isOpen: boolean;
    vocabs: Record<number, Vocab>;
    signVocabs: SignVocab[] | null;
    sign_id: number;
    handleAddVocab: () => void;
}

export default function SignVocabAddForm(
        {isOpen, vocabs, signVocabs, sign_id, handleAddVocab}: SignVocabAddFormProp
    ) {
    const usableVocabs = Object.values(vocabs).filter((vocab) => !signVocabs?.some((sign_vocab) => sign_vocab.vocab_id === vocab.vocab_id));

    const [addVocab, setAddVocab] = useState<number>(usableVocabs[0]?.vocab_id ?? -1);
    const [addVocabLevel, setAddVocabLevel] = useState<number>(1);

    
    const handleAdd = async (sign_vocab: SignVocab, callback: () => void) => {
        const response = await addSignVocab(sign_vocab);
        if (response.ok) {
            callback();
        }
    };

    if (!isOpen || usableVocabs.length === 0 || !HasPermission(teacher_permission)) return null;

    return <div className="d-flex mb-2">
        <select onChange={(e) => setAddVocab(Number(e.currentTarget.value))} value={ addVocab }>
            {usableVocabs.map((vocab, idx) => <option value={vocab.vocab_id} key={idx}>{vocab.name}</option>)}
        </select>
        <select onChange={(e) => setAddVocabLevel(Number(e.currentTarget.value))} value={ addVocabLevel }>
            {addVocab < 0 || Object.keys(vocabs).length === 0 ? <option value={1} >1</option> : 
                Array.from(Array(vocabs[addVocab].max_level).keys()).map((level, idx) =>
                    <option value={level+1} key={idx}>{level+1}</option>
                )
            }
        </select>
        <button onClick={() => {
            const vocab_sign = {sign_id: sign_id, vocab_id: addVocab, level: addVocabLevel};
            handleAdd(vocab_sign, handleAddVocab);
        }}>➕</button>
    </div>
}